"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SignatureType = exports.CreditAgency = exports.CreditPullMethod = void 0;
var CreditPullMethod;
(function (CreditPullMethod) {
    CreditPullMethod["PHONE"] = "PHONE";
    CreditPullMethod["INTERNET"] = "INTERNET";
    CreditPullMethod["FACE_TO_FACE"] = "FACE_TO_FACE";
})(CreditPullMethod = exports.CreditPullMethod || (exports.CreditPullMethod = {}));
var CreditAgency;
(function (CreditAgency) {
    CreditAgency["XACTUS"] = "XACTUS";
    CreditAgency["AVANTUS"] = "AVANTUS";
})(CreditAgency = exports.CreditAgency || (exports.CreditAgency = {}));
var SignatureType;
(function (SignatureType) {
    SignatureType["ESIGN"] = "ESIGN";
    SignatureType["WETSIGN"] = "WETSIGN";
})(SignatureType = exports.SignatureType || (exports.SignatureType = {}));
